import { OiWidgetSettings } from '../components/chartV2/chart.typings'
import { callColorCumulative, putColorCumulative } from '../components/multiStikeChart/styles'

export const defaultOiWidgetSettings: OiWidgetSettings = {
    showCall: true,
    showPut: true,
    callColor: callColorCumulative,
    putColor: putColorCumulative,
}
